import React from 'react';
import Spinner from '../ui/Spinner';

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="flex flex-col items-center gap-3">
      <Spinner size="lg" />
      <p className="text-sm text-gray-400">Loading...</p>
    </div>
  </div>
);

export default PageLoader;
